"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DemoContent = exports.DemoDiv = exports.StyledDropdown = exports.StyledMenu = void 0;
var styled_components_1 = require("styled-components");
var theme_1 = require("../../utils/theme");
var StyledMenuSlide = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    opacity: 0;\n    transform: translateY(-", ");\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0px);\n  }\n"], ["\n  0% {\n    opacity: 0;\n    transform: translateY(-", ");\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0px);\n  }\n"])), theme_1.scaffolding.sm);
exports.StyledMenu = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  animation: ", " 0.15s ease-out;\n  display: none;\n  outline: none;\n  position: absolute;\n  top: 100%;\n  :hover {\n    display: block;\n  }\n  :focus {\n    display: block;\n  }\n  :focus-within {\n    display: block;\n  }\n  left: ", ";\n  right: ", ";\n"], ["\n  animation: ", " 0.15s ease-out;\n  display: none;\n  outline: none;\n  position: absolute;\n  top: 100%;\n  :hover {\n    display: block;\n  }\n  :focus {\n    display: block;\n  }\n  :focus-within {\n    display: block;\n  }\n  left: ", ";\n  right: ", ";\n"])), StyledMenuSlide, function (props) { return (props.alignment === 'left' ? '0px' : 'auto'); }, function (props) { return (props.alignment === 'right' ? '0px' : 'auto'); });
var getMenuStyles = function (behaviour) {
    var _a, _b, _c;
    var menuSiblingSelector = (_a = {},
        _a["+ " + exports.StyledMenu] = {
            display: 'block'
        },
        _a);
    var hoverStyles = {
        '.ap-dropdown-trigger': {
            '&:hover': __assign({}, menuSiblingSelector)
        }
    };
    var clickStyles = {
        '.ap-dropdown-trigger': {
            '&:focus': __assign({}, menuSiblingSelector)
        }
    };
    var menuStyles = (_b = {},
        _b['click'] = __assign(__assign({}, clickStyles), (_c = {}, _c["@media (max-width: " + theme_1.breakpoints.dropdown + ")"] = __assign({}, hoverStyles), _c)),
        _b['hover'] = __assign({}, hoverStyles),
        _b);
    return menuStyles[behaviour];
};
exports.StyledDropdown = styled_components_1.default.div({
    display: 'inline-flex',
    position: 'relative',
    zIndex: 1
}, function (_a) {
    var behaviour = _a.behaviour;
    return (__assign({}, getMenuStyles(behaviour)));
});
exports.DemoDiv = styled_components_1.default.div({
    border: "1px dashed " + theme_1.colors.grey3
});
exports.DemoContent = styled_components_1.default.div({
    background: theme_1.colors.white,
    color: theme_1.colors.grey4,
    fontSize: '12px',
    padding: theme_1.scaffolding.sm,
    width: '200px',
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map